require('./_wks-define')('observable');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.1/core-js/library/modules/es7.symbol.observable.js
 ** module id = 80
 ** module chunks = 0
 **/